<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red" style="height: 3rem;">
        <div class="headerCon acea-row row-between-wrapper" style="height: 75%;">
          <div>
            <div class="name">我的团队</div> 
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      <div
        class="wrapper"
        style="
          color: rgb(227, 213, 174);
          font-size: 0.28rem;
          z-index: 2;
          width: 6.92rem;
          height: 1.15rem;
          margin: 0px auto;
          background-color: rgb(74, 62, 44);
          border-radius: 0.2rem 0.2rem 0px 0px;
          margin-top: -1.12rem;
        "
      >
        <div class="acea-row row-middle row-between-wrapper clearfix" style="height: 1.15rem">
          <div  style="width: 3.34rem; margin-left: 0.1rem;text-align: center;">
            团队（{{tuidui}}人）
          </div>
          <!-- <div  style="width: 3rem; text-align: center">直推 ({{zhitui}}人)</div> -->
        </div>
      </div>
      <div class="nav acea-row row-middle">
          <div class="item">
          <div>会员</div>
          <div class="num">{{huiyuan}}</div>
        </div>
        <div  class="item">
          <div>金卡</div>
          <div class="num">{{yinka}}</div>
        </div>
        <div  class="item">
          <div>白金卡</div>
          <div class="num">{{baijinka}}</div>
        </div> 
      </div> 
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索会员名称" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2"></div>
      </div>
    </div>
    <div class="list h_list"> 
      <div>
        <div
          class="item acea-row row-between-wrapper" v-if="spreadList.left">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="spreadList.left.avatar" /></div>
            <div class="text">
              <div class="name line1"></div>
              <div class="name line1">【左区】（{{userlevle(spreadList.left.level)}}）</div>
              <div class="name line1">{{ spreadList.left.nickname }}({{ spreadList.left.real_name }})</div>
              <div class="name line1">团队:{{ spreadList.left.count }}人</div> 
              <div>加入时间: {{ spreadList.left.time }}</div>
              <div style="display: flex; align-items: center; justify-content: center;">
                <span class="show_layer can_show_layer" style="width: 50%;" @click="next(prev)" v-if="prev">上一代</span>
                <span class="show_layer can_show_layer" style="width: 50%;" @click="next(spreadList.left.uid)">下一代</span>
              </div>
            </div>
          </div> 
        </div>
        <div
          class="item acea-row row-between-wrapper" 
          v-else>
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img src="@assets/images/user.png" /></div>
            <div class="text">
              <div class="name line1"></div>
              <div class="name line1">【左区】</div>
              <div class="name line1"></div> 
              <div style="display: flex; align-items: center; justify-content: center;">
                <span class="show_layer can_show_layer" style="width: 50%;" @click="next(prev)" v-if="prev">上一代</span>
                <router-link :to="{ path: '/register/'+userid+'/1'}" class="show_layer can_show_layer" style="width: 50%;" v-if="userInfo.is_promoter">注册</router-link>
              </div>
            </div>
          </div> 
        </div>

        <div
          class="item acea-row row-between-wrapper" 
          v-if="spreadList.right">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="spreadList.right.avatar" /></div>
            <div class="text">
              <div class="name line1"></div>
              <div class="name line1">【右区】（{{userlevle(spreadList.right.level)}}）</div>
              <div class="name line1">{{ spreadList.right.nickname }}({{ spreadList.right.real_name }})</div>
              <div class="name line1">团队:{{ spreadList.right.count }}人</div> 
              <div>加入时间: {{ spreadList.right.time }}</div>
              <div style="display: flex; align-items: center; justify-content: center;">
                <span class="show_layer can_show_layer" style="width: 50%;" @click="next(prev)" v-if="prev">上一代</span>
                <span class="show_layer can_show_layer" style="width: 50%;" @click="next(spreadList.right.uid)">下一代</span>
              </div>
            </div>
          </div> 
        </div>
        <div
          class="item acea-row row-between-wrapper" 
          v-else>
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img src="@assets/images/user.png" /></div>
            <div class="text">
              <div class="name line1"></div>
              <div class="name line1">【右区】</div>
              <div class="name line1"></div> 
              <div style="display: flex; align-items: center; justify-content: center;">
                <span class="show_layer can_show_layer" style="width: 50%;" @click="next(prev)" v-if="prev">上一代</span>
                <router-link :to="{ path: '/register/'+userid+'/2'}" class="show_layer can_show_layer" style="width: 50%;" v-if="userInfo.is_promoter">注册</router-link>
              </div>
            </div>
          </div> 
        </div>


      </div>
    </div>
    <!-- <Loading :loaded="loaded" :loading="loading"></Loading> -->
  </div>
</template>
<script>
import { getTuanduiUser,getUser } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "NetWorkList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      userInfo: {},
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        keyword: "",
        sort: "",
        parentid:0
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      userid:0, //注册安置人编号，panrent的编号，不是当前登录用户
      loadTitle: "",
      first: "",
      second: "",
      tuidui:"",
      zhitui:"",
      huiyuan:"",
      yinka:"",
      baijinka:"",
      prev:0
    };
  },
  mounted: function() { 
    this.User();
    this.getSpreadUsers(); 
  },
  watch: {
     
  },
  methods: { 
	userlevle:function(level){
		if(level==1){
			return "金卡";
		}else if(level==3){
			return "白金卡";
		}else{
			return "会员";
		}
	},
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.screen.parentid=res.data.uid;
      });
    },
    next:function(pid){
        let that = this;
        that.screen.parentid=pid;
        that.getSpreadUsers();
    },
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getTuanduiUser(screen).then(
        res => {
          that.loading = false;
          that.spreadList=res.data.list;
          that.userid = res.data.uid;
          that.tuidui = res.data.total;
          that.zhitui = res.data.zhitui;
          that.yinka = res.data.yinka;
          that.baijinka = res.data.baijin;
          that.huiyuan = res.data.huiyuan; 
          that.prev = res.data.prev; 
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    }
    
  }
};
</script>
<style>
.header  .nav{background-color:#fff;border-radius:0.06rem;height:1.4rem; line-height:.6rem; width: 6.92rem; margin: 0 auto; padding-top: .1rem; margin-bottom: 10px;}
.header  .nav .item{flex:1;-webkit-flex:1;-o-flex:1;-ms-flex:1;text-align:center;font-size:0.3rem;position:relative;}
.header  .nav .item~.item:after{position:absolute;content:'';left:0;width:1px;height:0.7rem;background-color:#eee;
top:50%;margin-top:-0.35rem;}
.header  .nav .item .num{font-size:0.36rem;color:#282828; line-height: .6rem;}

.promoter-list .list .item {
    height: auto;
    padding-bottom: .2rem;
    padding-top: .2rem
}

.show_layer {
    text-align: center;
    border: 1px solid #f1f1f1;
    margin-top: .2rem;
    line-height: .6rem;
    color: #999;
    font-size: .2rem;
    width: 50%;
    float: left
}
.can_show_layer {
    color: #000
}

</style>